import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import CallForActionSection from '../sections/home/call-for-action-section';
import OurStorySection from '../sections/home/our-story-section';
import HowItWorksSection from '../sections/home/how-it-works';
import ContactUsSection from '../sections/home/contact-us-section';
import { EmergencyHelp } from '../sections/survey/survey-result-components';
import { graphql } from 'gatsby';

const IndexPage = props => {
  return (
    <Layout>
      <SEO
        title="Ichhyashakti - Inspire. Engage. Educate. Empower. Collaborate"
        // link={
        //   <link rel="canonical" href="https://www.ichhyashakti.com" />
        // }
      />
      <CallForActionSection />
      <OurStorySection
        rosyImage={props.data.rosy.childImageSharp.fixed}
        banditaImage={props.data.bandita.childImageSharp.fixed}
      />
      <HowItWorksSection />
      <EmergencyHelp />
    </Layout>
  );
};
export default IndexPage;

export const pageQuery = graphql`
  query {
    rosy: file(relativePath: { eq: "rosy-image.JPG" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fixed(width: 200, height: 200) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    bandita: file(relativePath: { eq: "bandita-image.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fixed(width: 200, height: 200) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`;
